export default __webpack_public_path__ + "static/media/ALI-BAGHJARI.2de13892.pdf";